// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'
import SplashScreen from '@/components/SplashScreen.vue'

const routes = [
  {
    path: '/',
    name: 'Splash',
    component: SplashScreen
  },
  {
    // أي مسار آخر يُعاد توجيهه إلى Splash
    path: '/:catchAll(.*)*',
    redirect: '/'
  }
]

export default createRouter({
  history: createWebHistory(),
  routes
})
